import React, { useState, useEffect, useCallback, useRef } from 'react';
import axios from 'axios';
import { API } from '../config';
import { adminmi } from '../foydalanuvchi';
import { tr } from '../til';

// Kunlik hisobot — har kuni yarim tunda bo'lim boshlig'iga topshiriladigan
// varaq. Ilgari uni inspektor qo'lda to'ldirardi; endi hamma raqam
// bazadan keladi.
//
// O'tgan kunlar uchun server kun yakunida SAQLANGAN suratni beradi:
// topshirilgan varaqdagi son keyin o'zgarib ketmasligi kerak. Bugungi
// kun esa jonli hisoblanadi — sahifada qaysi biri ekani yozilib turadi.
//
// Chop etish va Word: tashqi kutubxonasiz. Chop etishda brauzerning o'zi
// PDF ga saqlaydi, Word esa HTML ni .doc qilib oladi — bu Word'da
// jadval bo'lib ochiladi va idoraviy hujjatga ko'chirishga yetarli.

const karta = {
  background: '#fff', borderRadius: '12px', padding: '20px',
  boxShadow: '0 1px 8px rgba(0,0,0,0.06)', marginBottom: '16px'
};

const input = {
  padding: '9px 11px', border: '1px solid #ddd',
  borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box'
};

const btn = {
  padding: '9px 16px', border: 'none', borderRadius: '8px',
  fontSize: '13px', cursor: 'pointer', color: '#fff', background: '#1a1a2e'
};

const USTUNLAR = [
  ['nazoratdagilar', tr("Nazoratda")],
  ['ilova_bor', tr("Ilova ulangan")],
  ['ilovasiz', tr("Ilovasiz")],
  ['signallar', tr("Signallar")],
  ['uydan_chiqdi', tr("Uydan chiqish")],
  ['aloqa_yoq', tr("Aloqa uzilishi")],
  ['soxta_gps', tr("Soxta GPS")],
  ['gps_ochirildi', tr("GPS/ruxsat")],
  ['tashrif', tr("Tashrif")],
  ['onlayn', tr("Onlayn")],
  ['telefon', tr("Telefon")],
  ['buzilish', tr("Buzilish")],
  ['dalolatnoma', tr("Dalolatnoma")],
  ['sayyor_sud', tr("Sayyor sud")],
];

const kecha = () => {
  const d = new Date(Date.now() - 24 * 60 * 60 * 1000);
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};

const bugun = () => {
  const d = new Date();
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};

function KunlikHisobot() {
  // Sukut bo'yicha KECHAGI kun: hisobot yarim tunda topshiriladi, ya'ni
  // odatda tugagan kun uchun kerak bo'ladi.
  const [sana, setSana] = useState(kecha());
  const [malumot, setMalumot] = useState(null);
  const [xato, setXato] = useState('');
  const [yuklanmoqda, setYuklanmoqda] = useState(true);
  const jadvalRef = useRef(null);

  const token = localStorage.getItem('token');
  const admin = adminmi();

  const yukla = useCallback(async () => {
    setYuklanmoqda(true);
    try {
      const r = await axios.get(`${API}/probatsiya/hisobot/kunlik`, {
        headers: { authorization: token }, params: { sana },
      });
      setMalumot(r.data);
      setXato('');
    } catch (err) {
      setXato(err.response?.data?.error || tr("Ma'lumotni olishda xato"));
    } finally {
      setYuklanmoqda(false);
    }
  }, [sana, token]);

  useEffect(() => { yukla(); }, [yukla]);

  const wordgaOlish = () => {
    if (!jadvalRef.current) return;
    const sarlavha = tr("Masofaviy nazorat — kunlik hisobot");
    const html = `<html xmlns:o="urn:schemas-microsoft-com:office:office"
        xmlns:w="urn:schemas-microsoft-com:office:word" xmlns="http://www.w3.org/TR/REC-html40">
      <head><meta charset="utf-8"><title>${sarlavha}</title>
      <style>
        body { font-family: "Times New Roman", serif; font-size: 11pt; }
        table { border-collapse: collapse; width: 100%; }
        th, td { border: 1px solid #000; padding: 4px 6px; font-size: 10pt; }
        th { background: #eee; }
        h2 { font-size: 13pt; }
      </style></head>
      <body>${jadvalRef.current.innerHTML}</body></html>`;

    const blob = new Blob(['﻿', html], { type: 'application/msword' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `masofaviy-nazorat-${sana}.doc`;
    a.click();
    URL.revokeObjectURL(a.href);
  };

  const d = malumot;

  return (
    <div>
      <h2 style={{ margin: '0 0 6px', fontSize: '22px' }}>📋 {tr("Kunlik hisobot")}</h2>
      <p style={{ margin: '0 0 16px', fontSize: '13px', color: '#666' }}>
        {tr("Masofaviy nazorat bo'yicha kun yakuni. Raqamlar bazadan avtomatik olinadi — qo'lda to'ldirish shart emas.")}
      </p>

      <div style={{ ...karta, display: 'flex', gap: '14px', alignItems: 'flex-end', flexWrap: 'wrap' }}>
        <div>
          <label style={{ display: 'block', fontSize: '12px', color: '#666', marginBottom: '4px' }}
            htmlFor="hisobot-sana">{tr("Sana")}</label>
          <input id="hisobot-sana" type="date" value={sana} max={bugun()}
            onChange={(e) => setSana(e.target.value || kecha())} style={input} />
        </div>
        <button onClick={() => window.print()} style={btn}>{tr("Chop etish / PDF")}</button>
        <button onClick={wordgaOlish} style={{ ...btn, background: '#2a5699' }}>
          {tr("Word (.doc)")}
        </button>
        <div style={{ marginLeft: 'auto', fontSize: '12px', color: '#888' }}>
          {yuklanmoqda ? tr("Yuklanmoqda...") : d && (
            d.manba === 'saqlangan'
              ? tr("Kun yakunida saqlangan — raqamlar o'zgarmaydi")
              : tr("Jonli hisob — kun hali tugamagan")
          )}
        </div>
      </div>

      {xato && (
        <div style={{ ...karta, background: '#fdeaea', color: '#b71c1c', fontSize: '14px' }}>{xato}</div>
      )}

      {d && (
        <div style={karta}>
          <div ref={jadvalRef}>
            <h2 style={{ margin: '0 0 4px', fontSize: '16px' }}>
              {tr("Masofaviy nazorat — kunlik hisobot")}
            </h2>
            <p style={{ margin: '0 0 12px', fontSize: '13px', color: '#555' }}>
              {tr("Sana: {sana}", { sana: d.sana })}
              {' · '}
              {tr("Ozodlikni cheklash jazosi · O'RQ-938, 403-son buyruq 84–85-band")}
            </p>

            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                <thead>
                  <tr>
                    <th style={{ border: '1px solid #ccc', padding: '6px', background: '#f3f5f9', textAlign: 'left' }}>
                      {tr("Tuman")}
                    </th>
                    {USTUNLAR.map(([k, nom]) => (
                      <th key={k} style={{ border: '1px solid #ccc', padding: '6px', background: '#f3f5f9' }}>
                        {nom}
                      </th>
                    ))}
                    <th style={{ border: '1px solid #ccc', padding: '6px', background: '#f3f5f9' }}>
                      {tr("Norma")}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {d.tumanlar.map((q) => (
                    <tr key={q.district_id}>
                      <td style={{ border: '1px solid #ddd', padding: '6px', fontWeight: 500 }}>{q.tuman}</td>
                      {USTUNLAR.map(([k]) => (
                        <td key={k} style={{ border: '1px solid #ddd', padding: '6px', textAlign: 'center' }}>
                          {q[k]}
                        </td>
                      ))}
                      <td style={{ border: '1px solid #ddd', padding: '6px', textAlign: 'center' }}>
                        {q.norma_bajarildi} / {q.norma_kerak}
                      </td>
                    </tr>
                  ))}
                  <tr style={{ fontWeight: 700, background: '#f7f9fc' }}>
                    <td style={{ border: '1px solid #ccc', padding: '6px' }}>{tr("JAMI")}</td>
                    {USTUNLAR.map(([k]) => (
                      <td key={k} style={{ border: '1px solid #ccc', padding: '6px', textAlign: 'center' }}>
                        {d.jami[k]}
                      </td>
                    ))}
                    <td style={{ border: '1px solid #ccc', padding: '6px', textAlign: 'center' }}>
                      {d.jami.norma_bajarildi} / {d.jami.norma_kerak}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p style={{ marginTop: '12px', fontSize: '11px', color: '#777' }}>
              {tr("Norma — oy boshidan hisoblangan jismoniy tashriflar (403-son buyruq, 84–85-bandlar). Onlayn va telefon tekshiruvi normani to'ldirmaydi.")}
            </p>
            {!admin && (
              <p style={{ fontSize: '11px', color: '#777' }}>
                {tr("Hisobotda faqat o'z tumaningiz ma'lumoti ko'rsatilgan.")}
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default KunlikHisobot;
